import { useState } from 'react'

const useConfirmation = () => {
    const [modalState, setModalState] = useState({ isOpen: false, resolve: null });

    const openConfirmation = () => {
        return new Promise((resolve) => {
            setModalState({ isOpen: true, resolve });
        });
    };

    const handleClose = () => {
        modalState.resolve(false);
        setModalState({ isOpen: false, resolve: null });
    };

    const handleConfirm = () => {
        modalState.resolve(true);
        setModalState({ isOpen: false, resolve: null });
    };

    return {
        isOpen: modalState.isOpen,
        openConfirmation,
        handleClose,
        handleConfirm
    };
};

export default useConfirmation; 